import * as React from 'react';
import { useSelector } from 'react-redux';
import { IState } from 'services/root-reducer';
import { getOperationSafe } from 'selectors';
import { MobileUILinkWindow } from 'mobile-ui/components/link-window';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';

export const MobileUIObjectLinkWindowWrapper = () => {
    let objectLinkOverlay = useSelector((state: IState) => getOperationSafe(state, 'OBJECT_LINK_OVERLAY'));

    if (!objectLinkOverlay.data?.visible) {
        return null;
    }

    return (
        <MobileUILinkWindow
            link={objectLinkOverlay.data?.link}
            onClose={() => {
                overlayWindowsActions.hideObjectLinkOverlay();
            }}
        />
    );
};
